import React from 'react';
import { Button, ButtonPriority, ButtonSize } from 'wix-ui-tpa/cssVars';
import { ClearXSmall } from '@wix/wix-ui-icons-common/on-stage/system';
import { classes, st } from './GenderChips.st.css';
import { FiltersDataHooks } from './dataHooks.const';
import { useCalendarActions } from '../../../Hooks/useCalendarActions';
import {
  FilterOption,
  FilterTypes,
  FilterViewModel,
} from '../../../ViewModel/filterViewModel/filterViewModel';
import {
  WidgetComponents,
  WidgetElements,
} from '../../../../../utils/bi/consts';
import { buildFilterUpdate, getStaffGenderOptions } from './utils';

type GenderChipsProps = {
  filterViewModels: FilterViewModel[];
};

export const GenderChips: React.FC<GenderChipsProps> = ({
  filterViewModels,
}) => {
  const { onFilterChanged, onElementClicked } = useCalendarActions();

  const genderOptions = getStaffGenderOptions(filterViewModels);

  if (!genderOptions.length) {
    return null;
  }

  const staffFilterLabel = filterViewModels.find(
    ({ id }) => id === FilterTypes.STAFF_MEMBER,
  )?.label;

  const toggleGender = (clickedOption: FilterOption) => {
    const updatedFilter = buildFilterUpdate({
      id: FilterTypes.STAFF_MEMBER,
      selectedOptions: clickedOption.selected ? [] : [clickedOption],
    });

    // The chips duplicate options the staff dropdown already offers, so they
    // need an element of their own to be told apart from it in BI.
    onElementClicked(
      WidgetComponents.FILTER,
      WidgetElements.GENDER_CHIP,
      updatedFilter,
    );
    void onFilterChanged(updatedFilter);
  };

  return (
    <div
      className={classes.genderChips}
      data-hook={FiltersDataHooks.GENDER_CHIPS}
      role="group"
      aria-label={staffFilterLabel}
    >
      {genderOptions.map((option) => (
        <Button
          upgrade
          key={option.value}
          size={ButtonSize.small}
          priority={
            option.selected
              ? ButtonPriority.primary
              : ButtonPriority.basicSecondary
          }
          className={st(classes.genderChip, { selected: option.selected })}
          data-hook={`${FiltersDataHooks.GENDER_CHIP}-${option.value}`}
          aria-pressed={option.selected}
          suffixIcon={
            option.selected ? (
              <ClearXSmall className={classes.genderChipSuffix} />
            ) : undefined
          }
          onClick={() => toggleGender(option)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};
